<template>
    <div class="modal-inner">
        <div class="photo-advice relative px-6 py-8 text-black">
            <ion-button class="close-btn" fill="clear" @click="dismiss" size="large" color="primary">
                <ion-icon slot="icon-only" :icon="closeIcon"></ion-icon>
            </ion-button>

            <h2 class="text-center text-2xl font-bold text-primary-dark mb-8 px-8">
                Petits conseils avant d'ajouter une photo !
            </h2>

            <ul class="space-y-6 mb-8 max-w-xl mx-auto">
                <li class="flex">
                    <span class="dot"></span>
                    <span>
                        Assure-toi que la photo soit de bonne qualité :<br>
                        Une largeur minimum de 1200 pixels est conseillée.<br>
                        Poids maximum : 20 Mo.
                    </span>
                </li>
                <li class="flex">
                    <span class="dot"></span>
                    <span>
                        Si tu n'es pas sûr.e de la qualité ou de comment ajouter ta photo, n'hésite pas à
                        demander à un proche !
                    </span>
                </li>
            </ul>

            <div class="text-center">
                <button-upload :callback="onFileSelected" @click="dismiss" shape="round" color="primary"
                               size="large" accept="image/*">
                    Ok
                </button-upload>
            </div>
        </div>
    </div>
</template>

<script>
import {
    IonButton,
    IonIcon,
    modalController
} from '@ionic/vue';
import { defineComponent } from 'vue';
import { close as closeIcon } from 'ionicons/icons';
import ButtonUpload from "@/components/ButtonUpload.vue";

export default defineComponent({
    name: 'ModalPhotoAdvice',
    components: {
        ButtonUpload,
        IonButton,
        IonIcon,
    },
    props: {
        callback: Function,
    },
    data() {
        return {
            closeIcon,
        };
    },
    methods: {
        onFileSelected: function (files) {
            if (this.callback) {
                this.callback(files);
            }
        },

        dismiss: function () {
            return modalController.dismiss(null, 'cancel');
        },
    },
});
</script>

<style lang="scss" scoped>
.photo-advice {

    .close-btn {
        @apply absolute top-2 right-2;
    }

    .dot {
        @apply shrink-0 mt-2 mr-3 w-3 h-3 rounded-full bg-primary;
    }
}
</style>
